<template>
  <div class="app" v-title data-title="预订服务-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="4" />
    <div class="yj-banner rel">
      <img src="@/assets/images/yd-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">预订服务</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">预订服务</div>
        <div class="f17 ls3">Reservation Services</div>
      </div>
    </div>
    <div class="spot-cont mt-40 pb100" v-if="data">
      <div class="spot-tit df align_center justify_center">
        <h2 class="f32 foo pb15">{{ data.Name }}</h2>
      </div>
      <div class="w1200 auto pt50 pb100" v-if="data.Items && data.Items && data.Items.length > 0" v-html="data.Items[0].ContentText">
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import promotionService from '@/services/client/cont/promotion'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      code: 'app-ydfw-hwfw',
      data: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      promotionService.detail(this.code).then(res => {
        if(res.Code == 200) {
          let data = res.Data;
          this.data = data;
        }
      })
    },
  },
}
</script>
<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/views/yuding/club.vue